import { type ReactElement } from 'react'
import { useConnectionSettings } from 'app/components/team/hierarchy/util/useConnectionSettings'
import { isNotDefined } from '@terros/common'
import { useProfile, useTeams } from '@front/model'
import { NotReady, TeamHierarchy } from '@components'

export const TeamPermissions = (): ReactElement => {
  const { data: teams, isLoading: isLoadingTeams, error } = useTeams()
  const [connectionSettings] = useConnectionSettings()
  const { company, isLoading: isLoadingProfile } = useProfile()

  if (isLoadingTeams || isLoadingProfile || !company || isNotDefined(teams) || error) {
    return (
      <div className='grid flex-1 place-content-center'>
        <NotReady data={teams} error={error} id='teams' isLoading={isLoadingTeams || isLoadingProfile} />
      </div>
    )
  }

  return <TeamHierarchy withPermissions company={company} connectionSettings={connectionSettings} teams={teams} />
}
